import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonFilesApiService } from '@common/generated-api/services/common-files-api.service';
import { AppService } from '@shared/services/app.service';
import { finalize, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FilesService {

  constructor(
    private commonFilesApiService: CommonFilesApiService,
    private appService: AppService,
    private httpClient: HttpClient
  ) {}

  downloadByUuid(uuid: string, fileName: string) {
    const stop = this.appService.startLoader();
    this.commonFilesApiService.getFile({ uuid }).pipe(
      switchMap(data => {
        return this.httpClient.get(data.result.url, { responseType: 'blob' });
      }),
      finalize(() => stop())
    ).subscribe({
      next: (data) => {
        if (data) {
          const dataBlob = data as unknown as BlobPart;
          const link = document.createElement('a');
          const blob = new Blob([ dataBlob ]);
          link.setAttribute('href', window.URL.createObjectURL(blob));
          link.setAttribute('download', fileName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    });
  }
}
